import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePostHog } from "@posthog/react";
import { isPostHogEnabled } from "../utils/posthog";

const PostHogPageViewTracker = () => {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    if (!isPostHogEnabled()) {
      return;
    }

    posthog.capture("$pageview", {
      $current_url: window.location.href,
    });
  }, [location.pathname, location.search, posthog]);

  return null;
};

export default PostHogPageViewTracker;
